<template>
  <div>
    <div v-if="isLoading">
      <b-row>
        <b-col>
          <h5>Cargando</h5>
        </b-col>
      </b-row>
    </div>
    <div v-if="!isLoading">
      <b-row>
        <b-col>
          <b-table :items="tableItems" :fields="itemsFields">
            <template #cell(x_student_id)="data">
              {{ data.item.x_student_id[1] }}
            </template>
            <template #cell(x_class_id)="data">
              {{ data.item.x_class_id[1] }}
            </template>
            <template #cell(x_enrollment_fee)="data">
              <input type="text" style="width:100px" v-model="data.item.x_enrollment_fee">
            </template>
            <template #cell(x_march_fee)="data">
              <input type="text" style="width:100px" v-model="data.item.x_march_fee">
            </template>
            <template #cell(x_monthly_fee)="data">
              <input type="text" style="width:100px" v-model="data.item.x_monthly_fee">
            </template>
            <template #cell(x_december_fee)="data">
              <input type="text" style="width:100px" v-model="data.item.x_december_fee">
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row v-if="!editarFacturasBool">
        <b-col>
          <b-button style="float:right" variant="outline-secondary" class="ml-2" @click="editarFacturas()">Editar</b-button>
          <b-button style="float:right" variant="outline-secondary" @click="executeActualizarCuentaCorriente()">Actualizar</b-button>
        </b-col>
      </b-row>
      <b-row v-if="editarFacturasBool">
        <b-col>
          <b-button style="float:right" variant="outline-secondary" class="ml-2" @click="cancelarEditarFacturas()">Cancelar</b-button>
          <b-button style="float:right" variant="outline-primary" @click="GuardarEditarFacturas()">Guardar</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5>Cuotas</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table :items="SO.invoice_ids" :fields="invoiceFields">
            <template #cell(date)="data">
              <div v-if="!editarFacturasBool || (data.item.state === 'posted' || data.item.state === 'cancel' )">
                {{data.item.invoice_date_due }}
              </div>
              <div v-if="editarFacturasBool && (data.item.state !== 'posted' && data.item.state !== 'cancel')">
                <b-input type="date" v-model="SO.invoice_ids[data.index].invoice_date_due"></b-input>
              </div>
            </template>
            <template #cell(display_name)="data">
              <div v-if="!editarFacturasBool || (data.item.state === 'posted' || data.item.state === 'cancel' )">
                <div style="font-size: 0.8em; line-height:10px;"><b-link :href="API_URL + '/report/html/account.report_invoice_with_payments/' + data.item.id">{{data.item.display_name}}</b-link></div>
                {{data.item.invoice_line_ids[0].name}}
              </div>
              <div v-if="editarFacturasBool && (data.item.state !== 'posted' && data.item.state !== 'cancel')">
                <b-input v-model="SO.invoice_ids[data.index].invoice_line_ids[0].name"></b-input>
              </div>
            </template>
            <template #cell(narration)="data">
                <div style="font-size: 0.8em; line-height:10px;">{{data.item.narration}}</div>
            </template>
            <template #cell(amount_total)="data">
              <div v-if="!editarFacturasBool || (data.item.state === 'posted' || data.item.state === 'cancel' )">
                <b>$ {{data.item.amount_total }}</b>
              </div>
              <div v-if="editarFacturasBool && (data.item.state !== 'posted' && data.item.state !== 'cancel')">
                <b-input v-model="SO.invoice_ids[data.index].amount_total"></b-input>
              </div>
            </template>
            <template #cell(state)="data">
              <b>{{  states[data.item.state] }}</b>
              <div v-if="editarFacturasBool && (data.item.state !== 'posted' && data.item.state !== 'cancel')">
                <b-button size="sm" variant="outline-secondary" @click="cancelarInvoice(data.item)">Cancelar</b-button>
              </div>
              <div v-if="editarFacturasBool && data.item.state === 'cancel'">
                <b-button size="sm" variant="outline-secondary" @click="volverABorrador(data.item)">Borrador</b-button>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import invoiceManagement from '../mixins/invoiceManagement'
import { SaleOrdersService } from '@/services/sale.orders.service'
import { SaleOrderLinesService } from '@/services/sale.order.lines.service'
import { AccountMoveService } from '@/services/account.move.service'
import { AccountMoveLineService } from '@/services/account.move.line.service'
import moment from 'moment'

export default {
  name: 'Families',
  props: ['order_id', 'family'],
  mixins: [invoiceManagement],
  data () {
    return {
      isLoading: true,
      SO: {},
      API_URL: AccountMoveService.API_URL(),
      filter: '',
      invoice_date_due: moment('12/02/2022'),
      itemsFields: [
        { key: 'x_student_id', label: 'Alumno' },
        { key: 'x_class_id', label: 'Clase' },
        { key: 'product_uom_qty', label: 'cant' },
        { key: 'x_enrollment_fee', label: 'Inscripción' },
        { key: 'x_march_fee', label: 'Marzo' },
        { key: 'x_monthly_fee', label: 'Mes' },
        { key: 'x_december_fee', label: 'Diciembre' }
      ],
      invoiceFields: [
        { key: 'date', label: 'Fecha Venc.', sortable: true, sortDirection: 'desc' },
        { key: 'display_name', label: 'Descripción', sortable: true, sortDirection: 'desc' },
        { key: 'narration', label: 'Comentario', sortable: true, sortDirection: 'desc' },
        { key: 'amount_total', label: 'Total', sortable: true, sortDirection: 'desc' },
        { key: 'state', label: 'Estado', sortable: true, sortDirection: 'desc' }
      ],
      states: { draft: 'Borrador', posted: 'Facturado', cancel: 'Cancelado' },
      editarFacturasBool: false
    }
  },
  computed: {
    tableItems () {
      const ret = []
      if (this.SO.order_line !== undefined) {
        for (let i = 0; i < this.SO.order_line.length; i++) {
          if (!this.SO.order_line[i].is_downpayment) {
            ret.push(this.SO.order_line[i])
          }
        }
      }
      // console.log(ret)
      return ret
    },
    sol () {
      return this.SO.order_line
    }
  },
  async created () {
    // console.log(this.order_id)
    await this.updateListado()
    console.log(this.SO)
    this.isLoading = false
  },
  methods: {
    async GuardarEditarFacturas () {
      for (let i = 0; i < this.SO.invoice_ids.length; i++) {
        const item = this.SO.invoice_ids[i]
        if (item.state === 'draft') {
          await AccountMoveService.update(item.id, { invoice_date_due: item.invoice_date_due })
          await AccountMoveLineService.update(item.invoice_line_ids[0].id, { name: item.invoice_line_ids[0].name, price_unit: item.invoice_line_ids[0].amount_total })
        }
      }
    },
    async updateListado () {
      this.SO = await SaleOrdersService.read([this.order_id], [])
      this.SO = this.SO[0]
      this.SO.order_line = await SaleOrderLinesService.read(this.SO.order_line, [])
      this.SO.invoice_ids = await AccountMoveService.read(this.SO.invoice_ids, [])
      const invoicelinesPromises = []
      for (let i = 0; i < this.SO.invoice_ids.length; i++) {
        invoicelinesPromises.push(AccountMoveLineService.read(this.SO.invoice_ids[i].invoice_line_ids))
      }
      const items = await Promise.all(invoicelinesPromises)
      for (let i = 0; i < this.SO.invoice_ids.length; i++) {
        this.SO.invoice_ids[i].invoice_line_ids = items[i]
      }
      console.log(this.SO)
    },
    cancelarEditarFacturas () {
      this.editarFacturasBool = false
    },
    async volverABorrador (item) {
      this.isLoading = true
      try {
        await AccountMoveService.execute('button_draft', [[item.id]])
      } catch (error) {
        console.log(error)
      }
      
      await this.updateListado()
      this.isLoading = false
    },
    async cancelarInvoice (item) {
      this.isLoading = true
      try {
        await AccountMoveService.execute('button_cancel', [[item.id]])
      } catch (error) {
        console.log(error)
      }
      
      await this.updateListado()
      this.isLoading = false
    },
    editarFacturas () {
      this.editarFacturasBool = true
    },
    async executeActualizarCuentaCorriente () {
      this.isLoading = true
      await this.actualizarCuentaCorriente()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
